<!-- SessionTimeoutModal.vue -->
<template>
  <div v-if="show" class="modal-overlay">
    <div class="modal-content">
      <h3>Session Expiring</h3>
      <p>Your session will expire in {{ countdown }} seconds</p>
      <div class="modal-actions">
        <button class="button success" @click="refreshSession">
          Stay Logged In
        </button>
        <button class="button danger" @click="logout">
          Logout Now
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SessionTimeoutModal',
  data() {
    return {
      show: false,
      countdown: 10,
      timer: null
    }
  },
  methods: {
    startCountdown() {
      this.show = true;
      this.countdown = 10;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.cleanup();
          this.$emit('expire');
        }
      }, 1000);
    },
    cleanup() {
      clearInterval(this.timer);
      this.show = false;
    },
    refreshSession() {
      this.cleanup();
      this.$emit('refresh');
    },
    logout() {
      this.cleanup();
      this.$emit('expire');
    }
  },
  beforeDestroy() {
    this.cleanup();
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.modal-actions {
  margin-top: 15px;
}

.button {
  margin: 0 8px;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  border: none;
}

.success {
  background: #47a3f3;
  color: white;
}

.danger {
  background: #dc3545;
  color: white;
}
</style>
